module.exports = __webpack_public_path__ + "img/54.6006f829.png";